import { createFileRoute } from '@tanstack/react-router';
import { Text, VStack } from 'ui_2';
import { Step, useBuyGiveawayStore } from './-buyGiveawayStore';
import { Route as giveaway_route } from '@routes/giveaways/$programId';
import { Route as index_route } from '@routes/index';
import Buy from './-01_View';
import Header from '@src/components/layout/Header';
import Confirmed from './-02_Confirmed';
import { Page } from '@src/components/layout/Page';
import { Sheet } from 'react-modal-sheet';
import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';

export const Route = createFileRoute('/giveaways/$programId/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { isPuzzleWalletWebview } = useArcadeStoreState();
  const [step, _close] = useBuyGiveawayStore((state) => [
    state.step,
    state.close,
  ]);

  const giveaway = giveaway_route.useLoaderData();
  const { showHeader, showAccountAndBalance } = giveaway_route.useSearch();

  if (!giveaway) {
    return (
      <VStack>
        <Header backRoute={index_route.to} title='Buy Entries' />
        <Text>Could not find giveaway!</Text>
      </VStack>
    );
  }

  return (
    <>
      <Page
        backRoute={isPuzzleWalletWebview ? undefined : index_route.to}
        title={giveaway.title}
        onBack={_close}
        showAccountAndBalance={showAccountAndBalance}
        showHeader={showHeader}
      >
        <Buy giveaway={giveaway} />
      </Page>
      <Sheet
        className='mx-auto max-w-[750px]'
        isOpen={step === Step._02_Confirmed}
        onClose={() => _close()}
        detent='content-height'
        style={{ zIndex: 10 }}
      >
        <Sheet.Container
          style={{
            borderTopLeftRadius: '20px',
            borderTopRightRadius: '20px',
          }}
          className='p-4 pb-8'
        >
          <Confirmed />
        </Sheet.Container>
        <Sheet.Backdrop onTap={() => _close()} />
      </Sheet>
    </>
  );
}
